import { apiClient, getHeaders, serializeQueryParams } from '@/services/axiosConfig'

export default {
  // START - Get Products
  // START - Get Products Public
  getHomeProducts (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getTodayPromotionProducts (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/today-promotion',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getOnSaleBrandPartnerProducts (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/on-sale-brand-partner',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getOnSaleStorePartnerProducts (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/on-sale-store-partner',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getRecomendationProduct (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/recommendation',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getTopPickProducts (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/top-picks',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getBestSellerProducts (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/products/best-seller',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getNewProducts (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/new-products',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getMostReviewedProducts (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/most-reviewed',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getBestSellerHomePage (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/homepage-best-seller',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getProductsSale (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/products/on-sale',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getEstimatePrice (auth, payload) {
    return apiClient({
      method: 'post',
      url: 'v1/products/get-price-with-shipping-cost',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getProductShippingCostEstimate (auth, payload) {
    return apiClient({
      method: 'get',
      url: `v1/products/${payload.productId}/shipping-cost`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getProductBestSellingMonthly (auth, payload) {
    return apiClient({
      method: 'post',
      url: 'v1/products/best-selling-this-month',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getPopularAffiliateMonthly (auth, payload) {
    return apiClient({
      method: 'post',
      url: 'v1/products/affiliate-popular-this-month',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getNearbyLocationProduct (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/products/nearby-location',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getCatalogAffiliate (auth, payload) {
    return apiClient({
      method: 'post',
      url: `v1/products/${payload.section}`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getProductSection (auth, section, payload) {
    const isLastSeen = section === 'last-seen'
    return apiClient({
      method: isLastSeen ? 'get' : 'post',
      url: '/v1/products/' + section,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value),
        ...(isLastSeen ? { 'Session-id': auth.sessionId } : {})
      },
      ...payload,
      ...(isLastSeen ? { data: undefined, params: payload.data, paramsSerializer: serializeQueryParams } : {})
    })
  },
  getMetaProduct (auth, slug) {
    return apiClient({
      method: 'post',
      url: '/v1/products/' + slug + '/meta-scripts',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      }
    })
  },
  getProductReviews (auth, id, payload) {
    return apiClient({
      method: 'post',
      url: `v1/products/${id}/reviews`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getProductReviewFiles (auth, id, payload) {
    return apiClient({
      method: 'post',
      url: `v1/products/${id}/reviews/files`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getDetailReviewProduct (auth, payload) {
    return apiClient({
      method: 'get',
      url: `v1/reviews/${payload.id}`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // END - Get Products Public

  // START - Get Products General
  getLastSeenProducts (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/general/products/last-seen',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value),
        'Session-id': auth.sessionId
      },
      ...payload,
      data: undefined,
      params: payload.data,
      paramsSerializer: serializeQueryParams
    })
  },
  getProductsLastSeen (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/general/products/last-seen',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value),
        'Session-id': auth.sessionId
      },
      ...payload,
      paramsSerializer: serializeQueryParams
    })
  },
  getProductAffiliate (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/general/affiliate-products',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getProductUnAffiliated  (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/general/products/unaffiliated',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // END - Get Products General
  // END - Get Products

  // START - Delete Products
  deleteProductsLastSeen (auth, payload) {
    return apiClient({
      method: 'delete',
      url: '/v1/general/products/last-seen',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // END - Delete Products

  // START - Detail Product
  getDetailProduct (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/products/' + payload.slug,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getFulfilledDetailProduct (auth, payload) {
    return apiClient({
      method: 'get',
      url: `/v1/products/${payload.slug}/fulfilled-by-paninti`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getAlternativeDetailProduct (auth, payload) {
    const { slug, sessionId, ...config } = payload

    return apiClient({
      method: 'get',
      url: `/v1/products/${slug}/offers/alternative`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...config
    })
  },
  // END - Detail Product

  // START - Others
  // START - Affiliate Products
  addProductAffiliate (auth, payload) {
    return apiClient({
      method: 'put',
      url: '/v1/general/affiliate-products',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  deleteAffiliateProduct (auth, payload) {
    return apiClient({
      method: 'delete',
      url: '/v1/general/affiliate-products',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // END - Affiliate Products

  // START - Order Products
  getProductNotReviewed (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/general/order-products/not-reviewed',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // START - Order Products

  // START - Event Sale Products
  getProductsEventSale (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/event-sale-products',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getEventSaleProductsNew (auth, payload) {
    return apiClient({
      method: 'get',
      url: `/v1/event-sale-products${payload.strParams ? `?${payload.strParams}` : ''}`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // END - Event Sale Products

  // START - Event Sale Session
  getProductsPreSaleSession (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/event-sale-sessions',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // END - Event Sale Session

  // START - Users
  getProductWishlist (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/general/users/my-product-wishlists',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getProductsWishlist (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/general/users/my-product-wishlists',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getAffiliateTopProducts (auth, payload) {
    return apiClient({
      method: 'get',
      url: `v1/users/${payload.username}/affiliate-top-products`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getAffiliateAllProduct (auth, payload) {
    return apiClient({
      method: 'get',
      url: `/v1/users/${payload.username}/affiliate-products`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // END - Users

  // START - Catalogs
  getProductCategory (auth, payload) {
    return apiClient({
      method: 'post',
      url: 'v1/catalogs/category/products',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  // New API's Products using Search Engine
  getProductSearch (auth, payload) {
    return apiClient({
      method: 'get',
      url: `/v1/products${payload.strParams ? `?${payload.strParams}` : ''}`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  }
  // END - Catalogs
  // END - Others
}
